import { useCallback } from 'react';
export default function useDebounce(cb, delay) {
  var handler;
  return useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (handler) {
      clearTimeout(handler);
    }

    handler = setTimeout(function () {
      cb.apply(void 0, args);
      handler = null;
    }, delay);
  }, [cb, delay]);
}